import {
  Component,
  ElementRef,
  Input,
  OnDestroy,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
  EventEmitter,
} from "@angular/core";
import videojs from "video.js";
import qualityLable from "videojs-contrib-quality-levels";
videojs.registerPlugin("qualityLable", qualityLable);
import hlsQualitySelector from "videojs-hls-quality-selector";
videojs.registerPlugin("hlsQualitySelector", hlsQualitySelector);
import seekButon from "videojs-seek-buttons";
videojs.registerPlugin("seekButon", seekButon);
import "videojs-contrib-ads";
import "videojs-ima";
import { BaseService } from "src/app/base/base.service";
// import shareVideo from "videojs-share";
// videojs.registerPlugin("shareVideo", shareVideo);

@Component({
  selector: "audio-vjs-player",
  // templateUrl: './vjs-player.component.html',
  // 'vjs-big-play-centered' class to make play button center.
  template: `<audio
    id="my-video"
    #target
    class="video-js audio-js"
    playsinline
    preload="none"
    controls
  ></audio>`,
  styleUrls: ["./audio-player.component.css"],
  encapsulation: ViewEncapsulation.None,
})
export class audioPlayerComponent implements OnInit, OnDestroy {
  userInfo: any = {};
  config: any;
  @ViewChild("target", { static: true }) target: ElementRef;
  @Input() playList: any;
  @Input() public set playinStatus(value: any) {
    if (this.player) {
      if (value) {
        this.player.play();
      } else {
        this.player.pause();
      }
    }
  }
  @Input() public set options(value) {
    this.config = value;
    if (this.player) {
      this.player.src(this.config.sources[0]);
    }
  }
  player: videojs.Player;
  // tslint:disable-next-line: variable-name
  @Output() buttonStatus = new EventEmitter<{ button: string }>();
  @Output() playerStatus = new EventEmitter();
  constructor(public baseservice: BaseService) {}

  ngOnInit(): void {
    // instantiate Video.js
    this.player = videojs(
      this.target.nativeElement,
      this.config,
      function onPlayerReady() {}
    );

    var button = videojs.getComponent("Button");
    var next = videojs.extend(button, {
      constructor: function () {
        button.apply(this, arguments);
        this.controlText("Next");
        this.addClass("icon-next");
      },
      handleClick: () => {
        this.buttonStatus.emit({ button: "next" });
        // this.player().dispose();
      },
    });

    var prev = videojs.extend(button, {
      constructor: function () {
        button.apply(this, arguments);
        this.controlText("Prev");
        this.addClass("icon-prew");
      },
      handleClick: () => {
        this.buttonStatus.emit({ button: "prev" });
        // this.player().dispose();
      },
    });
    videojs.registerComponent("next", next);
    this.player.getChild("controlBar").addChild("next", {});
    videojs.registerComponent("prev", prev);
    this.player.getChild("controlBar").addChild("prev", {});
    this.player.on("ended", () => {
      this.playerStatus.emit({ status: "complete" });
    });

    this.player.on("play", () => {
      this.baseservice.audioStatus = true;
    });

    this.player.on("pause", () => {
      this.playerStatus.emit({ audioStatus: "false" });
    });
  }
  ngOnDestroy() {
    if (this.player) {
      this.player.dispose();
    }
  }
}
